import { useContext, useState } from "react";
import "./orderOffers.styles.scss";
import { OrderOffersContext } from "../../../../contexts/orderOffers.context";

const orderOfferInitial = {
  orderValue: "",
  orderPercentage: "",
};
const OrderOffers = () => {
  const [orderFields, setOrderFields] = useState(orderOfferInitial);
  const [addClass, setAddClass] = useState("oo-add-hidden");
  const [addButton, setAddButton] = useState("Add +");

  const { orderOffersContext, setOrderOffersContext } =
    useContext(OrderOffersContext);
  console.log(orderOffersContext);
  const { orderValue, orderPercentage } = orderFields;

  const handleChange = (e) => {
    const { value, name } = e.target;
    setOrderFields({ ...orderFields, [name]: value });
  };
  const handleClassChange = () => {
    if (addClass === "oo-add-hidden") {
      setAddClass("oo-add-visible");
      setAddButton("Close -");
    } else if (addClass === "oo-add-visible") {
      setAddClass("oo-add-hidden");
      setAddButton("Add +");
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    var i = 1;
    var newObject = {};
    Object.keys(orderOffersContext).map((index) => {
      newObject = { ...newObject, [i]: orderOffersContext[index] };
      i++;
    });
    newObject = { ...newObject, [i]: orderFields };
    setOrderOffersContext(newObject);
    setOrderFields(orderOfferInitial);
    handleClassChange();
  };

  const handleDelete = (indexValue) => {
    var i = 1;
    var newObject = {};
    Object.keys(orderOffersContext).map((index) => {
      if (index !== indexValue) {
        newObject = { ...newObject, [i]: orderOffersContext[index] };
        i++;
      }
    });
    setOrderOffersContext(newObject);
  };
  return (
    <div className="order-offers-container">
      <div className="order-offers-top">
        <span className="oo-top-description">
          Add order based offers (Like : 10% off on orders above 1000)
        </span>
        <span className="oo-add-container" onClick={handleClassChange}>
          {addButton}
        </span>
      </div>
      <div className={addClass}>
        <form onSubmit={handleSubmit} className="oo-add-form">
          <div className="oo-add-inputs">
            <input
              type="text"
              name="orderValue"
              placeholder="Order Value"
              onChange={handleChange}
              value={orderValue}
              className="oo-add-input"
            />
            <input
              type="text"
              name="orderPercentage"
              placeholder="Offer % (Like 10,20)"
              onChange={handleChange}
              value={orderPercentage}
              className="oo-add-input"
            />
          </div>
          <button type="submit" className="oo-add-button">
            Add Offer
          </button>
        </form>
      </div>
      <div className="order-offers-bottom">
        {Object.keys(orderOffersContext).length === 0 ? (
          <div className="oo-bottom-message-container">
            <span className="oo-bottom-message">
              You haven't added any offers yet. Start by clicking on Add.
            </span>
          </div>
        ) : (
          <div className="oo-bottom-offers">
            {Object.keys(orderOffersContext).map((index) => {
              const tempObject = orderOffersContext[index];
              return (
                <div className="oo-bottom-offer">
                  <div className="oo-bottom-offer-details">
                    <span className="oo-bottom-offer-value">
                      <span className="oo-bottom-tag">Order Value : </span>
                      {tempObject["orderValue"]}
                    </span>
                    <span className="oo-bottom-offer-percentage">
                      <span className="oo-bottom-tag">Order Percentage : </span>
                      {tempObject["orderPercentage"]}%
                    </span>
                  </div>
                  <span
                    className="oo-bottom-offer-delete"
                    onClick={() => handleDelete(index)}
                  >
                    Delete
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderOffers;
